export const GET = 'GET';
export const POST = 'POST';

export let USERIDTORESTRICT = [];
export let TENANTIDTORESTRICT = [];
export let ADVANCEDWIDGETSUSERIDS=[];
export let GENERATE_PAYMENT_LINK_AUTHORISED_IDS=[];
export let APP_MOVEMENT_AUTHORISED_IDS=[];
export const SALES_ROLE = 'studio-user';
export const PAYMENT_LINK_CREATOR = 'subscription.paymentLinkCreator';
export const ADMINUI_USER_CREATE_ROLE = 'adminui.user.create';
export const ADMINUI_USER_DELETE_ROLE = 'adminui.user.remove';
export const ADMINUI_ROLE_MOVEAPPS = 'adminui.role.moveapps';
export const ADMINUI_ROLE_MULTIPLE_DEPLOY = 'adminiui.role.deployexception';
export const ADMINUI_ROLE = 'adminui.view';
export const ADMINUI_PAYMENTS_GENERATE_LINK_ROLE = 'adminui.payments.generatelink';
export const ADMINUI_DOMAIN_READ_MANAGEMENT_ROLE = 'adminui.domain.read';
export const ADMINUI_DOMAIN_WRITE_MANAGEMENT_ROLE = 'adminui.domain.readwrite';
export const ADMINUI_PAYMENTS_APPLY_DISCOUNT_ROLE = 'adminui.payments.applydiscount';
export const ADMINUI_PAYMENTS_ADD_CHARGE_ROLE = 'adminui.payments.addcharge';
export const ADMINUI_PAYMENTS_SYNC_PAYMENT_ROLE = 'adminui.payments.syncpayment';
export const ADMINUI_SUBSCRIPTION_DOWNLOAD_INVOICE_ROLE = 'adminui.subscription.downloadinvoice';
export const ADMINUI_SUBSCRIPTION_CUSTOM_INVOICE_ROLE = 'adminui.subscription.custominvoice';
export const ADMINUI_SUBSCRIPTION_VIEW_TIMELINE_ROLE = 'adminui.subscription.viewtimeline';
export const ADMINUI_ADMIN_ROLE = 'adminui.admin';
export const ENABLE_MULTIPLE_DOMAIN = true;